"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaLibraryUploaderBase = void 0;
class MediaLibraryUploaderBase {
    static async getMediaByIdentifier(relatedEntityId) {
        throw new Error('Method getMediaByIdentifier is not implemented');
    }
    static async uploadImageFromPc(options) {
        throw new Error('Method uploadImageFromPc is not implemented');
    }
    static async uploadDocumentFromPc(options) {
        throw new Error('Method uploadDocumentFromPc is not implemented');
    }
    static async uploadAudioFromPc(options) {
        throw new Error('Method uploadAudioFromPc is not implemented');
    }
    static async uploadAudioFromRecording(blob) {
        throw new Error('Method uploadAudioFromRecording is not implemented');
    }
    static async uploadVideoFromPc(options) {
        throw new Error('Method uploadVideoFromPc is not implemented');
    }
    static async uploadDroppedImageFromPc(event) {
        throw new Error('Method uploadDroppedImageFromPc is not implemented');
    }
    static async uploadDroppedDocumentFromPc(event) {
        throw new Error('Method uploadDroppedDocumentFromPc is not implemented');
    }
    static async uploadDroppedAudioFromPc(event) {
        throw new Error('Method uploadDroppedAudioFromPc is not implemented');
    }
    static async uploadDroppedVideoFromPc(event) {
        throw new Error('Method uploadDroppedVideoFromPc is not implemented');
    }
    static async uploadFiles(files, type) {
        throw new Error('Method uploadFiles is not implemented');
    }
}
exports.MediaLibraryUploaderBase = MediaLibraryUploaderBase;
